/**
 * @description: 卡券报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-kq-report">
        <div class="kq-list" v-show="!showBillDetail">
            <el-form :inline="true" size="small" :model="kq_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="kq_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="kq_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="kq_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="kq_list_form.shop_id" filterable clearable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="送券方式" v-show="getListType=='1'">
                    <el-select v-model="kq_list_form.from_palce" filterable clearable placeholder="请选择送券方式">
                        <el-option label="会员注册送券" value="1"></el-option>
                        <el-option label="扫码领券" value="2"></el-option>
                        <el-option label="会员充值送券" value="3"></el-option>
                        <el-option label="麦霸大赛奖励券" value="4"></el-option>
                        <el-option label="活动送券" value="5"></el-option>
                        <el-option label="个人专享券" value="6"></el-option>
                        <el-option label="生日礼券" value="7"></el-option>
                        <el-option label="会员邀请注册奖励券" value="8"></el-option>
                        <el-option label="消费送券" value="9"></el-option>
                        <el-option label="股东赠送会员卡送券" value="14"></el-option>
                        <el-option label="会员邀请充值奖励券" value="16"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡券类型">
                    <el-select v-model="kq_list_form.type" filterable clearable placeholder="请选择卡券类型">
                        <el-option label="红包券" value="1"></el-option>
                        <el-option label="物品券" value="2"></el-option>
                        <el-option label="物品套餐券" value="3"></el-option>
                        <el-option label="开房套餐券" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡券状态" v-show="getListType=='1'">
                    <el-select v-model="kq_list_form.status" filterable clearable placeholder="请选择卡券状态">
                        <el-option label="未使用" value="1"></el-option>
                        <el-option label="被占用" value="2"></el-option>
                        <el-option label="已使用" value="9"></el-option>
                        <el-option label="已过期" value="-2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡券名称">
                    <el-input v-model="kq_list_form.name" clearable placeholder="请输入卡券名称"></el-input>
                </el-form-item>
                <el-form-item v-show="getListType=='1'">
                    <el-input placeholder="请输入检索内容" v-model="queryContent">
                        <el-select class="el-slot-select" v-model="queryType" slot="prepend" placeholder="请选择">
                            <el-option label="会员手机号" value="1"></el-option>
                            <el-option label="会员卡号" value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="活动名称" v-show="getListType=='1'">
                    <el-input v-model="kq_list_form.activity_name" clearable placeholder="请输入活动名称或ID"></el-input>
                </el-form-item>
                <el-form-item label="包厢" v-show="getListType=='2'">
                    <el-input v-model="kq_list_form.room_id" clearable placeholder="请输入包厢号"></el-input>
                </el-form-item>
                <el-form-item label="账单号" v-show="getListType=='2'">
                    <el-input v-model="kq_list_form.bill_no" clearable placeholder="请输入账单号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button :type="getListType==1?'primary':''" @click="changeList(1)">领券明细</el-button>
                    <el-button :type="getListType==2?'primary':''" @click="changeList(2)">使用明细</el-button>
                    <el-button type="primary" @click="kqQuery">查询</el-button>
                    <el-button @click="kqExportSet" v-if="getListType=='1'">导出</el-button>
                    <el-button @click="usedExportSet" v-else>导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-if="getListType=='1'"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="kq_list"
                :key="tableKey">
                <el-table-column prop="get_time" label="领券时间" width="150px"></el-table-column>
                <el-table-column prop="from_palce_name" label="送券方式"></el-table-column>
                <el-table-column prop="type_name" label="卡券类型"></el-table-column>
                <el-table-column prop="name" label="卡券名称"></el-table-column>
                <el-table-column prop="value" label="卡券价值"></el-table-column>
                <el-table-column prop="status_name" label="卡券状态"></el-table-column>
                <el-table-column prop="shop_name" label="使用门店"></el-table-column>
                <el-table-column prop="vip_name" label="领取会员"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="vip_mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="ahead_user_name" label="微信昵称"></el-table-column>
                <el-table-column prop="activity_name" label="活动名称"></el-table-column>
            </el-table>
            <div class="pagination-row" v-if="getListType=='1'">
                <div>
                    <label class="list-label-5">卡券总数量:</label>
                    <div class="list-total">{{kq_list_total}}</div>
                    <label class="list-label-5">卡券总价值:</label>
                    <div class="list-total">{{kq_total_value}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="kq_list_page"
                    :total="kq_list_total"
                    @current-change="getKqList">
                </el-pagination>
            </div>
            <el-table
                v-if="getListType=='2'"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="kq_list"
                :key="tableKey">
                <el-table-column prop="create_time" label="使用时间" width="150px"></el-table-column>
                <el-table-column prop="type_name" label="卡券类型"></el-table-column>
                <el-table-column prop="name" label="卡券名称"></el-table-column>
                <el-table-column prop="value" label="卡券价值"></el-table-column>
                <el-table-column prop="room_name" label="使用包厢"></el-table-column>
                <el-table-column prop="bill_no" label="账单号"></el-table-column>
                <el-table-column prop="reward_shop_name" label="领取门店"></el-table-column>
                <el-table-column prop="vip_name" label="领取会员"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="vip_mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="ahead_user_name" label="微信昵称"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="checkBillDetail(scope.row.bill_no)">账单详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="getListType=='2'"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="kq_list_page"
                :total="kq_list_total"
                @current-change="getUsedList">
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="kq_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="kq_export_sign" v-model="kq_export_all" @change="kqExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="kq_export_ids" @change="kqExportChange">
                    <el-checkbox label="get_time">领券时间</el-checkbox>
                    <el-checkbox label="from_palce_name">送券方式</el-checkbox>
                    <el-checkbox label="type_name">卡券类型</el-checkbox>
                    <el-checkbox label="name">卡券名称</el-checkbox>
                    <el-checkbox label="value">卡券价值</el-checkbox>
                    <el-checkbox label="status_name">卡券状态</el-checkbox>
                    <el-checkbox label="shop_name">使用门店</el-checkbox>
                    <el-checkbox label="vip_name">领取会员</el-checkbox>
                    <el-checkbox label="vip_card">会员卡号</el-checkbox>
                    <el-checkbox label="vip_mobile">会员手机号</el-checkbox>
                    <el-checkbox label="ahead_user_name">微信昵称</el-checkbox>
                    <el-checkbox label="activity_name">活动名称</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="kq_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="kq_export_type" label="2">pdf文件</el-radio>
            </div>
            <div class="export-wrap" ref="used_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="used_export_sign" v-model="used_export_all" @change="usedExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="used_export_ids" @change="usedExportChange">
                    <el-checkbox label="create_time">使用时间</el-checkbox>
                    <el-checkbox label="type_name">卡券类型</el-checkbox>
                    <el-checkbox label="name">卡券名称</el-checkbox>
                    <el-checkbox label="value">卡券价值</el-checkbox>
                    <el-checkbox label="room_name">使用包厢</el-checkbox>
                    <el-checkbox label="bill_no">账单号</el-checkbox>
                    <el-checkbox label="reward_shop_name">领取门店</el-checkbox>
                    <el-checkbox label="vip_name">领取会员</el-checkbox>
                    <el-checkbox label="vip_card">会员卡号</el-checkbox>
                    <el-checkbox label="vip_mobile">会员手机号</el-checkbox>
                    <el-checkbox label="ahead_user_name">微信昵称</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="kq_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="kq_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
        <!-- 账单详情 -->
        <div class="bill-detail" v-show="showBillDetail">
            <billDetail ref="bill_det" @backBdwPre="showBillDetail=false"></billDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                kq_list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    from_palce: '',
                    type: '',
                    status: '',
                    name: '', // 卡券名称
                    vip_card: '', // 会员卡号
                    vip_mobile: '', // 会员手机号
                    activity_name: '', // 活动名称
                    room_id: '',
                    bill_no: '',
				},
                getListType: '1', // 1领券明细 2使用明细
                queryType: '1', // 1会员手机号 2会员卡号
                queryContent: '',
				kq_list: [],
				kq_list_page: 1,
                kq_list_total: 0,
                kq_export_sign: false,
				kq_export_all: false,
                kq_export_ids: [],
                kq_export_list: ['get_time', 'from_palce_name', 'type_name', 'name', 'value', 'status_name', 'shop_name', 'vip_name', 'vip_mobile', 'vip_card', 'ahead_user_name', 'activity_name'],
                kq_export_type: '1',
                kq_total_value: '',
                tableKey: Math.random(),
                used_export_sign: false,
                used_export_all: false,
                used_export_ids: [],
                used_export_list: ['create_time', 'type_name', 'name', 'value', 'room_name', 'bill_no', 'reward_shop_name', 'vip_name', 'vip_mobile', 'vip_card', 'ahead_user_name'],
                showBillDetail: false,
            }
        },
        components: {
            "billDetail": billDetail,
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if(val.params.vip_card) {
                        this.getListType = '1'
                        this.queryType = '2'
                        this.queryContent = val.params.vip_card
                        this.getKqList(1)
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.kq_list_form.start_time = moment().subtract(1, 'day').format('YYYY-MM-DD 08:00');
            this.kq_list_form.end_time = moment().format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.kq_list_form.shop_id = this.shop_list[0].id;
                // 第一次打开
                if(this.$route.params.vip_card) {
                    console.log(this.$route.params)
                    this.getListType = '1'
                    this.queryType = '2'
                    this.queryContent = this.$route.params.vip_card
                } 
                this.getKqList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.kq_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.kq_list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.kq_list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            getKqList(page) {
				const _this = this;

				_this.loading = true;
                _this.kq_list_page = page;
				Vue.axios.post('FinanceReport2/userRewardList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.kq_list_form.start_time,
                            "end_time": _this.kq_list_form.end_time,
							"shop_id": _this.kq_list_form.shop_id,
							"from_palce": _this.kq_list_form.from_palce,
							"type": _this.kq_list_form.type,
							"status": _this.kq_list_form.status,
                            "name": _this.kq_list_form.name,
                            "vip_mobile": _this.queryType == '1'? _this.queryContent : '',
                            "vip_card": _this.queryType == '2'? _this.queryContent : '',
                            "activity_name": _this.kq_list_form.activity_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.kq_list_total = Number(res.data.response.count)
							_this.kq_total_value = res.data.response.total_value
						}
                        _this.tableKey = Math.random();
						_this.kq_list = res.data.response.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            getUsedList(page) {
                const _this = this;

                _this.loading = true;
                _this.kq_list_page = page;
                Vue.axios.post('FinanceReport2/userRewardUseList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.kq_list_form.start_time,
                            "end_time": _this.kq_list_form.end_time,
                            "shop_id": _this.kq_list_form.shop_id,
                            "type": _this.kq_list_form.type,
                            "name": _this.kq_list_form.name,
                            "room_id": _this.kq_list_form.room_id,
                            "bill_no": _this.kq_list_form.bill_no,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.kq_list_total = Number(res.data.response.count)
                        }
                        _this.tableKey = Math.random();
                        _this.kq_list = res.data.response.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

			// 查询
			kqQuery() {
                if (this.getListType == '1') {
				    this.getKqList(1);
                }else {
                    this.getUsedList(1)
                }
            },
            // 切换列表类型
            changeList(type) {
                this.getListType = type
                this.kqQuery()
            },
            // 导出
            kqExportAll(val) {
				this.kq_export_ids = val ? this.kq_export_list : [];
				this.kq_export_sign = false;
			},
			kqExportChange(val) {
				const len = val.length;
				this.kq_export_all = len === this.kq_export_list.length;
				this.kq_export_sign = len > 0 && len < this.kq_export_list.length;
			},
            kqExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport2/userRewardListExport"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.kq_export_ids = res.data.response.result.export_fields;
                            _this.kq_export_type = res.data.response.result.export_type;
                        } else {
                            _this.kq_export_ids = _this.kq_export_list;
                            _this.kq_export_type = '1';
                        }
                        _this.kqExportChange(_this.kq_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.kq_list_export)
                }, function() {
                    _this.kqExport();
                });
            },
            kqExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/userRewardListExport" +
                    "?start_time=" + this.kq_list_form.start_time +
                    "&end_time=" + this.kq_list_form.end_time +
                    "&shop_id=" + this.kq_list_form.shop_id +
                    "&from_palce=" + this.kq_list_form.from_palce +
                    "&type=" + this.kq_list_form.type +
                    "&status=" + this.kq_list_form.status +
                    "&name=" + this.kq_list_form.name + 
                    "&vip_mobile=" + (this.queryType == '1'? this.queryContent : '') +
                    "&vip_card=" + (this.queryType == '2'? this.queryContent : '') +
                    "&activity_name=" + this.kq_list_form.activity_name +
                    "&export_fields=" + JSON.stringify(this.kq_export_ids) +
                    "&export_type=" + this.kq_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },

            // 使用卡券导出
            usedExportAll(val) {
                this.used_export_ids = val ? this.used_export_list : [];
                this.used_export_sign = false;
            },
            usedExportChange(val) {
                const len = val.length;
                this.used_export_all = len === this.used_export_list.length;
                this.used_export_sign = len > 0 && len < this.used_export_list.length;
            },
            usedExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "report_type": "FinanceReport2/exportUserRewardUseList"
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(res.data.response.result) {
                            _this.used_export_ids = res.data.response.result.export_fields;
                            _this.kq_export_type = res.data.response.result.export_type;
                        } else {
                            _this.used_export_ids = _this.kq_export_list;
                            _this.kq_export_type = '1';
                        }
                        _this.usedExportChange(_this.used_export_ids);
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.used_list_export)
                }, function() {
                    _this.usedExport();
                });
            },
            usedExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/exportUserRewardUseList" +
                    "?start_time=" + this.kq_list_form.start_time +
                    "&end_time=" + this.kq_list_form.end_time +
                    "&shop_id=" + this.kq_list_form.shop_id +
                    "&type=" + this.kq_list_form.type +
                    "&name=" + this.kq_list_form.name + 
                    "&room_id=" + this.kq_list_form.room_id +
                    "&bill_no=" + this.kq_list_form.bill_no +
                    "&export_fields=" + JSON.stringify(this.kq_export_ids) +
                    "&export_type=" + this.kq_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },

            // 查看账单
            checkBillDetail(bill_no) {
                this.$refs.bill_det.getBdwDetail(bill_no)
                this.showBillDetail = true
            },
        }
    }
</script>
<style lang="less" scoped>
    .kq-list {
    }
</style>